import mainGameBG from '../../asset/images/background/BG_MAIN.jpg'
import freeGameBG from '../../asset/images/background/BG_FREE_1.jpg'
import freeGameSuperBG from '../../asset/images/background/BG_FREE_2.jpg'
import desktopBGMG from '../../asset/images/image_webBGMain.jpg'
import desktopBGFG from '../../asset/images/image_webBGFree.jpg'
import { Assets } from 'pixi.js'
import { memo, useEffect, useRef } from 'react'
import { useGameStore } from '../domain/game/store/GameStore'
import spineBGSkel from '/resource/spine/background/spine_BG.skel?url'
import spineBGAtlas from '/resource/spine/background/spine_BG.atlas?url'
import { Container as PixiContainer } from 'pixi.js'
import { Container } from '@pixi/react'
import { Spine } from '@esotericsoftware/spine-pixi'
import { gameConfig } from '../config'
import { FreeGameType } from '../domain/buybonus/enum/buyBonusEnum'
import { SpinePlayer } from '@slot-nx/core'
import { useGodziDropStore } from '../domain/godziDrop/store/godziDropStore'

Assets.addBundle('background', {
  mainGameBG: { src: mainGameBG, loadParser: 'loadTextures' },
  freeGameBG: { src: freeGameBG, loadParser: 'loadTextures' },
  freeGameSuperBG: { src: freeGameSuperBG, loadParser: 'loadTextures' },
  desktopBGMG: { src: desktopBGMG, loadParser: 'loadTextures' },
  desktopBGFG: { src: desktopBGFG, loadParser: 'loadTextures' },
})

export const getBackgroundSpineData = () => {
  const backgroundSpineData = [
    { alias: 'spineBGSkel', src: spineBGSkel },
    { alias: 'spineBGAtlas', src: spineBGAtlas },
  ]

  return backgroundSpineData
}

export const Background = () => {
  const { freeGameType, isFreeGame } = useGameStore()
  const sceneRef = useRef<PixiContainer>()
  const { isLoadedAssets } = useGameStore()

  useEffect(() => {
    if (isLoadedAssets) {
      spine = Spine.from(spineBGSkel, spineBGAtlas, { autoUpdate: true })
      sceneRef.current?.addChild(spine)
      const triggerAni = `01_mainGame`
      changeBackground(triggerAni)
    }
  }, [isLoadedAssets])

  useEffect(() => {
    if (isLoadedAssets) {
      let spineName = '01_mainGame'
      if (isFreeGame && freeGameType === FreeGameType.YummyFreeGame) {
        spineName = '02_freeGame'
      }
      else if (isFreeGame && freeGameType === FreeGameType.HeavenlyFreeGame) {
        spineName = '03_superFreeGame'
      }
      changeBackground(spineName)
    }
  }, [freeGameType, isFreeGame, isLoadedAssets])

  return (
    <Container
      name="background"
      eventMode="static"
      ref={(el: PixiContainer | null) => {
        sceneRef.current = el as PixiContainer
      }}
    >
    </Container>
  )
}
let spine: Spine
const changeBackground = (spineName: string) => {
  spine.x = gameConfig.resolution.width / 2
  spine.y = gameConfig.resolution.height / 2
  const currentAnimation = spine.state.getCurrent(0)
  if (!currentAnimation || !currentAnimation.animation || currentAnimation.animation.name !== spineName) {
    spine.state.setAnimation(0, spineName, true)
  }
}
export const GodziBg = memo(() => {
  const isShowGodziFire = useGodziDropStore(state => state.isShowGodziFire)
  const { isLoadedAssets } = useGameStore()

  return (
    <Container
      name="godziFire"
      x={550}
      y={1650}
      visible={isLoadedAssets}
    >
      <Container
        name="godziFire_L"
        visible={isLoadedAssets}
      >
        {isLoadedAssets && isShowGodziFire
        && (
          <SpinePlayer
            width={720}
            x={0}
            y={0}
            data="godziBgSkel"
            atlas="godziBgAtlas"
            loop={true}
            animationStr="anim2"
            scale={1.5}
          />
        )}

      </Container>

    </Container>
  )
})
